// Local list of affid values, not the authoritative registry.
// Adding new IDs should first be added through Admin before updating this enum.
//
// Affiliates created via Admin (the Mongo registry) won't get a name/Datadog mapping
// here until this enum is manually refreshed against it -- accepted as a periodic manual step.
export enum AffiliateId {
  TEST = '1',
  GREY_STATE_VENTURES = '2',
  STRINGO_FB = '3',
  WISDOM_INTERNAL = '4',
  GRAYPIVOT = '5',
  STRINGO_NATIVE = '6',
  PBM_FB = '7',
  PBM_GOOGLE = '8',
  NURTURE = '9',
  PBM_GSP = '10',
  PBM_YT = '11',
  PBM_CALL_ONLY = '12',
  JIMMY_BING = '13',
  PBM_TIKTOK = '14',
  PBM_PINTEREST = '15',
  OUTBRAIN = '16',
  WISDOM_EMAIL = '17',
  DIRECT_AGENTS = '19',
  KEEPCOOL = '20',
  FINDENERGY = '21',
  AURORA_BLOG = '22',
  QDM = '23',
  SOLAR_EXCLUSIVE = '24',
  MINITOOLS = '32',
  EMBED = '34',
  // 35-97 are free as of 2026-07-21
  GEN_ALT_PATH = '99',
}

export const getAffiliateName = (affiliateId: AffiliateId | undefined): string | undefined => {
  return Object.entries(AffiliateId).find(([, value]) => value === affiliateId)?.[0];
};

const AFFILIATE_ID_PATTERN = /^[1-9]\d{0,5}$/;

export const deriveAffiliateId = (
  affIdParam: string | undefined,
  referrer?: string | null
): AffiliateId | undefined => {
  if (affIdParam && AFFILIATE_ID_PATTERN.test(affIdParam)) {
    return affIdParam as AffiliateId;
  }

  if (referrer) {
    if (referrer.startsWith('https://www.google.')) {
      return AffiliateId.PBM_GOOGLE;
    }
    if (referrer.includes('facebook.com') || referrer.includes('instagram.com')) {
      return AffiliateId.PBM_FB;
    }
  }

  return undefined;
};
